// NPM
import React, { PureComponent } from 'react';
import { debounce, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { GET_MORE_RECOMMENDATIONS } from 'actionTypes';
import {
  entitiesListSelector,
  recommendationFiltersActive,
  fetchingRecommendations,
  isActionInProgress,
} from 'selectors';

// Components
import Recommendation from './Recommendation';
import EmptyRecommendationList from './EmptyRecommendationList';
import RecommendationHideMenu from './RecommendationHideMenu';

import {
  GlobalEventWrapper,
  LoadingIndicator,
} from 'frontend-component-library';

class RecommendationList extends PureComponent {
  constructor(props) {
    super(props);
    this.lastChild = null;

    this.globalEventTriggers = {
      scroll: [
        {
          callback: this.onScroll,
          conditional: this.shouldFetchMore,
        },
      ],
    };
  }

  attachLastChild = node => {
    if (node) {
      this.lastChild = node.getWrappedInstance();
    }
  };

  shouldFetchMore = () => {
    const { isFetching, isFetchingMore } = this.props;

    if (!this.lastChild) {
      return false;
    }

    const box = this.lastChild.getBoundingBox();
    return (
      this.hasMore() &&
      !isFetching &&
      !isFetchingMore &&
      window.innerHeight > box.top
    );
  };

  onScroll = debounce(() => this.props.getMoreRecommendations(), 200);

  showFavoriteButton = () => {
    const { filters, areResultsOwnedByUser } = this.props;
    return !filters.isHidden && areResultsOwnedByUser;
  };

  showHideButton = () => {
    const { filters, areResultsOwnedByUser } = this.props;
    return !filters.isFavorite && areResultsOwnedByUser;
  };

  renderRecommendation = (recommendation, i) => {
    let refFunc;
    if (i === this.props.recommendations.length - 1) {
      refFunc = this.attachLastChild;
    }
    if (recommendation.uuid === this.props.hidingRecommendation) {
      return (
        <li key={recommendation.uuid}>
          <RecommendationHideMenu recommendation={recommendation} />
        </li>
      );
    } else {
      return (
        <li key={recommendation.uuid}>
          <Recommendation
            page={this.props.page}
            recommendation={recommendation}
            showHideButton={this.showHideButton()}
            showFavoriteButton={this.showFavoriteButton()}
            ref={refFunc}
          />
        </li>
      );
    }
  };

  hasMore = () => {
    const { pagination } = this.props;
    return !!pagination.next;
  };

  render() {
    const {
      recommendations,
      isFetching,
      filtersAreActive,
      noResultsText,
      areResultsOwnedByUser,
    } = this.props;
    if (isFetching) {
      return (
        <div className="RecommendationsList loading">
          <LoadingIndicator isLoading={true} />
        </div>
      );
    } else if (isEmpty(recommendations)) {
      return (
        <EmptyRecommendationList
          areResultsOwnedByUser={areResultsOwnedByUser}
          noResultsText={noResultsText}
        />
      );
    } else {
      return (
        <GlobalEventWrapper
          className="RecommendationsList"
          triggers={this.globalEventTriggers}
        >
          {filtersAreActive && <h2>Top programs</h2>}
          <ol>{recommendations.map(this.renderRecommendation)}</ol>

          <LoadingIndicator isLoading={this.hasMore()} />
        </GlobalEventWrapper>
      );
    }
  }
}

RecommendationList.defaultProps = {
  pagination: {
    next: 1,
  },
  noResultsText: 'default',
  areResultsOwnedByUser: false,
};

function mapStateToProps(state) {
  return {
    filters: state.filters,
    filtersAreActive: recommendationFiltersActive(state),
    recommendations: entitiesListSelector(state, 'recommendations'),
    isFetching: fetchingRecommendations(state),
    isFetchingMore: isActionInProgress(state, GET_MORE_RECOMMENDATIONS),
    pagination: state.pagination.recommendations,
    hidingRecommendation: state.hidingRecommendation,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMoreRecommendations: actions.getMoreRecommendations,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationList);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationList.js